/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */

import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { FormError, FormDatePicker as FormDatePickerOptions } from '.';

const FormDatePicker = (props) => {
  const { validateEmployment, ...pickerProps } = props;
  const { label, name, minDate, maxDate, disabled } = pickerProps;
  const { t } = useTranslation();
  const validateDate = (value) => {
    if (disabled || !value || !moment(value).isValid()) return undefined;
    const date = moment(value);
    if (
      (minDate && date.isBefore(minDate, 'day')) ||
      (maxDate && date.isAfter(maxDate, 'day'))
    ) {
      return t('dateOutsideAllowedPeriod');
    }
    return undefined;
  };

  return (
    <Form.Group controlId={`form${name}`} className="form-group">
      <Form.Label>{label}</Form.Label>
      <FormDatePickerOptions
        {...pickerProps}
        validate={validateEmployment ? validateDate : undefined}
      />
      <FormError {...props} />
    </Form.Group>
  );
};

FormDatePicker.defaultProps = {
  name: '',
  label: '',
  disabled: false,
  minDate: undefined,
  maxDate: undefined,
  validateEmployment: false,
};

FormDatePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  validateEmployment: PropTypes.bool,
};

export default FormDatePicker;
